import { useEffect, useState } from 'react';

export function useResendTimer(key, cooldownSeconds = 600) {
  const [timeLeft, setTimeLeft] = useState(0);
  const [isAllowed, setIsAllowed] = useState(true);

  useEffect(() => {
    const lastSent = localStorage.getItem(key);

    if (lastSent) {
      const elapsed = Math.floor((Date.now() - Number(lastSent)) / 1000);
      const remaining = Math.max(cooldownSeconds - elapsed, 0);

      if (remaining > 0) {
        setIsAllowed(false);
        setTimeLeft(remaining);
      }
    }
  }, [key, cooldownSeconds]);

  useEffect(() => {
    if (!isAllowed) {
      const interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsAllowed(true);
            localStorage.removeItem(key);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isAllowed, key]);

  const startTimer = () => {
    localStorage.setItem(key, Date.now().toString());
    setIsAllowed(false);
    setTimeLeft(cooldownSeconds);
  };

  return { isAllowed, timeLeft, startTimer };
}
